import Vue from 'vue'
import Router from 'vue-router'


Vue.use(Router)

export default new Router({
    routes: [{
            path: '/',
            name: 'home',
            component: () =>
                import ("@/pages/Index")
        },
        {
            path: '/ranking',
            name: 'ranking',
            component: () =>
                import ("@/pages/ranking")
        },
        {
            path: '/findmore',
            name: 'findmore',
            component: () =>
                import ("@/pages/Findmore")
        },
        {
            path: '/recommend',
            name: 'recommend',
            component: () =>
                import ("@/pages/recommend")
        },
        {
            path: '/map',
            name: 'map',
            component: () =>
                import ("@/pages/MapSearch")
        },
        
    ]
})



// WEBPACK FOOTER //
// ./src/router/index.js